"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Support() {
  const services = [{
    tag: "— DDS QUALIFIED",
    title: "Individualized Day Support (IDS)",
    description: "Tailored daily programs focused on personal growth and skill building.",
    features: ["Daily Living Skills", "Goal Tracking", "Personal Advocacy", "Skill Building"],
    price: "Inquire",
    popular: false
  }, {
    tag: "— DDS QUALIFIED",
    title: "Individualized Home Support (IHS)",
    description: "One-on-one assistance to maintain independence within your own home.",
    features: ["Home Management", "Safety Planning", "Health Monitoring", "Budgeting"],
    price: "Inquire",
    popular: true
  }, {
    tag: "— DDS QUALIFIED",
    title: "Respite Care",
    description: "Temporary relief for primary caregivers while ensuring continuous quality support.",
    features: ["Caregiver Relief", "Safe Environment", "Social Interaction", "24/7 Support"],
    price: "Inquire",
    popular: false
  }, {
    tag: "— DDS QUALIFIED",
    title: "Day Support Options (DSO)",
    description: "Group-based activities designed to enhance social and vocational skills.",
    features: ["Group Activities", "Vocational Prep", "Social Skills", "Community Access"],
    price: "Inquire",
    popular: false
  }, {
    tag: "— DDS QUALIFIED",
    title: "Community Engagement",
    description: "Active participation in local events to build meaningful social connections.",
    features: ["Social Outings", "Volunteer Projects", "Peer Networking", "Local Events"],
    price: "Inquire",
    popular: false
  }, {
    tag: "— DDS QUALIFIED",
    title: "Family Consultation",
    description: "Expert guidance for families navigating the DDS system and care planning.",
    features: ["System Navigation", "Resource Planning", "Care Coordination", "Advocacy"],
    price: "Inquire",
    popular: false
  }];
  return <section data-section-id="3432" id="comprehensive-support" className="bg-[hsl(215_16%_12%)] text-[hsl(210_20%_98%)] py-24 md:py-40 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center mb-20 md:mb-28">
          <p className="font-mono text-xs md:text-sm tracking-widest text-[hsl(195_100%_45%)] mb-8 uppercase">
            — Our Services
          </p>
          <h2 className="font-serif font-default text-5xl md:text-7xl lg:text-[88px] leading-[1.05] tracking-tight text-[hsl(210_20%_98%)] max-w-5xl">
            Empowering <em className="italic font-light">Lives</em>
            <br />
            through <em className="italic font-light">Stability.</em>
          </h2>
          <p className="font-sans text-lg md:text-xl text-[hsl(215_15%_75%)] leading-relaxed mt-10 max-w-[600px]">
            Waters Well Inc. provides state-qualified support services in Connecticut. We combine clinical precision with radical empathy to ensure every individual reaches their full potential.
          </p>

          <div className="mt-14 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 font-mono text-xs md:text-sm tracking-widest text-[hsl(215_15%_75%)] uppercase">
            <span>— DDS Certified</span>
            <span className="w-1 h-1 rounded-lg bg-[hsl(195_100%_45%)]" />
            <span>CT Based</span>
            <span className="w-1 h-1 rounded-lg bg-[hsl(195_100%_45%)]" />
            <span>Person-Centered</span>
          </div>
        </div>

        <div className="mb-16 text-center max-w-3xl mx-auto">
          <p className="font-sans text-lg md:text-xl text-[hsl(210_20%_98%)] leading-relaxed">
            We help adults with intellectual disabilities. Waters Well Inc. is a Connecticut DDS-qualified provider offering person-centered support services.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {services.map((service, i) => <article key={i} data-index={i} className="relative bg-[hsl(215_16%_16%)] text-[hsl(210_20%_98%)] rounded-lg p-8 md:p-12 border border-[hsl(215_15%_30%)] flex flex-col shadow-lg">
              {service.popular && <div className="absolute top-6 right-6 md:top-8 md:right-8 z-10">
                  <div className="bg-[hsl(195_100%_45%)] text-white font-mono text-[10px] md:text-xs tracking-widest uppercase px-3 py-1.5 rounded-lg border border-white">
                    Featured
                  </div>
                </div>}

              <p className="font-mono text-xs tracking-widest text-[hsl(195_100%_45%)] uppercase mb-4">
                {service.tag}
              </p>

              <h3 className="font-serif font-default text-2xl md:text-3xl lg:text-[32px] leading-tight text-[hsl(210_20%_98%)] mb-4">
                {service.title}
              </h3>

              <p className="font-sans text-base md:text-lg text-[hsl(215_15%_75%)] leading-relaxed mb-8 line-clamp-2">
                {service.description}
              </p>

              <ul className="mb-10 border-t border-[hsl(215_15%_30%)]">
                {service.features.map((feature, j) => <li data-index={j} key={j} className="flex items-center justify-between font-mono text-xs md:text-sm tracking-widest text-[hsl(210_20%_98%)] uppercase py-3 border-b border-[hsl(215_15%_30%)]">
                    <span>— {feature}</span>
                  </li>)}
              </ul>

              <div className="mt-auto flex items-end justify-between gap-4">
                <div>
                  <p className="font-mono text-[10px] tracking-widest text-[hsl(215_15%_75%)] uppercase mb-1">
                    — Availability
                  </p>
                  <p className="font-serif font-default text-2xl text-[hsl(210_20%_98%)]">
                    {service.price}
                  </p>
                </div>
                <Button variant="link" asChild className="font-mono text-xs tracking-widest uppercase text-[hsl(210_20%_98%)] hover:no-underline border-b border-[hsl(215_15%_30%)] rounded-lg hover:border-[hsl(195_100%_45%)] pb-1 px-0 h-auto">
                  <Link to="/GetInTouchPage">
                    Apply
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </Link>
                </Button>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}